import { makeStyles, createStyles } from '@material-ui/core'

export const useCreateButtonsStyles = makeStyles((theme) =>
  createStyles({
    container: {
      margin: 0,
      [theme.breakpoints.down(960)]: {
        margin: '30px 0 20px'
      }
    },
    buttonAdd: {
      textTransform: 'none',
      width: 'fit-content',
      padding: '3px 12px',
      [theme.breakpoints.down(960)]: {
        fontSize: 12
      }
    },
    linkAdd: {
      width: 'fit-content'
    }
  })
)
